import { HttpQueryConfig } from '../../core/model/HttpQueryConfig.model';

export const CustomersHttpQuery: HttpQueryConfig = {
  GetCustomers: {
    key: 'GetCustomers',
    url: '/api/customers',
    errors: {},
  },
};
